import React from 'react'
import { WKSearch } from '../../components/wk'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { browserHistory } from 'react-router'
import * as relayAction from '../../actions/relays'


class RelaySearchBox extends React.Component {
    componentDidMount () {
        document.querySelector('.weui-search-bar form').setAttribute('action', '.')
        // document.querySelector('.weui-search-bar .weui-search-bar__input').value = '23'
    }
    onChangeKeyword (text, e) {
        // if (this.props.tabId === 0) {
            this.props.relaySetLectureKeyword(text)
        // } else {
            this.props.relaySetChannelKeyword(text)
        // }
    }
    onSubmit (e) {
        // if (this.props.tabId === 0) {
            this.props.relaySetLectureList(null)
            this.props.relaySetLectureOffset(0)
            this.props.relaySetLectureHasMore(true)
            this.props.relayFetchLectureList()
            // this.replaceLocation('lecture', this.props.lectureKeyword)
        // } else {
            this.props.relaySetChannelList(null)
            this.props.relaySetChannelOffset(0)
            this.props.relaySetChannelHasMore(true)
            this.props.relayFetchChannelList()
            // this.replaceLocation('channel', this.props.channelKeyword)
        // }
        if (this.props.tabId === 0) {
            this.replaceLocation('lecture', this.props.lectureKeyword)
        } else {
            this.replaceLocation('channel', this.props.channelKeyword)
        }
    }
    replaceLocation (type, keyword) {
        if (type === 'lecture') {
            console.log(keyword)
            browserHistory.replace(`/specials/relay/lecture?keyword=${keyword}`)
        } else {
            browserHistory.replace(`/specials/relay/channel?keyword=${keyword}`)
        }
    }
    onCancel () {
        // if (this.props.tabId === 0) {
            this.props.relaySetLectureList(null)
            this.props.relaySetLectureKeyword('')
            this.props.relaySetLectureOffset(0)
            this.props.relaySetLectureHasMore(true)
            this.props.relayFetchLectureList()
            // this.replaceLocation('lecture', '')
        // } else {
            this.props.relaySetChannelList(null)
            this.props.relaySetChannelKeyword('')
            this.props.relaySetChannelOffset(0)
            this.props.relaySetChannelHasMore(true)
            this.props.relayFetchChannelList()
            // this.replaceLocation('channel', '')
        // }
        if (this.props.tabId === 0) {
            this.replaceLocation('lecture', '')
        } else {
            this.replaceLocation('channel', '')
        }
    }
    render() {
        const keyword = this.props.tabId === 0 ? this.props.lectureKeyword : this.props.channelKeyword
        return (
            <WKSearch
                placeholder={"搜索课程／专栏名称"}
                lang={{
                    cancel: '取消'
                }}
                className='margin-bottom'
                onChange={(text, e) => this.onChangeKeyword(text, e)}
                onSubmit={e => this.onSubmit(e)}
                onCancel={e => this.onCancel()}
                defaultValue={keyword}
            />
        )
    }
}


export default connect(state => ({
    lectureKeyword: state.relay.lectureKeyword,
    channelKeyword: state.relay.channelKeyword,
    tabId: state.component.wkTab.selectId,
}), dispatch => bindActionCreators({ ...relayAction }, dispatch))(RelaySearchBox)



// WEBPACK FOOTER //
// ./src/components/relays/RelaySearchBox.js